module.exports = __webpack_public_path__ + "c31eec9388e55470b7867ea2b42b8442.svg";